<template>
  <ion-page>
    <ion-content :fullscreen="false" color="light">
      <!-- <random-fact /> -->
      <ion-card v-if="userStore.is.student">
        <ion-card-header>
          <ion-card-title v-if="branding.name === 'SwingMatch Golf'">Welcome to {{ branding.name }}!</ion-card-title>
          <ion-card-title v-if="branding.name === 'Blackhawk Academy'">Welcome to the Blackhawk Academy!</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <p v-if="branding.name === 'SwingMatch Golf'" class="welcome-text">
            Thank you for joining SwingMatch, your gateway to better golf! We're excited to help you improve your game and connect with the perfect instructor.
          </p>
          <div v-if="branding.name === 'Blackhawk Academy'" class="welcome-text">
            <p>
              We're excited to make it easier than ever for you to book lessons with our PGA professional instructors. You can view available times, book a lesson, manage your lesson bookings, and look at instructor notes from previous lessons — all in one place.
            </p>

            <p>To get started:</p>

            <p>
              <ul class="ion-no-margin">
                <li>Click "Book Lesson"</li>
                <li>Select your instructor and click "Book Lesson"</li>
                <li>Select your lesson type and book an open slot!</li>
              </ul>
            </p>
            <p>We look forward to helping you <strong>PLAY BETTER GOLF</strong>.</p>
          </div>

          <p style="text-align:center" class="ion-padding-top">
            <ion-button color="success" :router-link="{name: 'newLesson'}">Book Lesson</ion-button>
          </p>
        </ion-card-content>
      </ion-card>
      <upcoming-lessons />
      <purchased-packages-block v-if="userStore.is.student" />
      <ion-card v-if="userStore.is.instructor" class="insights-card">
        <ion-card-header>
          <ion-card-title>Reports &amp; Insights</ion-card-title>
          <ion-card-subtitle>Stay on top of payouts and lesson momentum.</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content class="insights-card__actions">
          <ion-button
            expand="block"
            fill="outline"
            color="medium"
            :router-link="{ name: 'reports' }"
          >
            View Reports
          </ion-button>
          <ion-button
            expand="block"
            fill="outline"
            color="medium"
            :router-link="{ name: 'schedules' }"
          >
            Review Schedule
          </ion-button>
        </ion-card-content>
      </ion-card>
      <share-profile-block />
      <ion-card v-if="userStore.is.instructor && branding.name === 'SwingMatch Golf'" class="contact-card">
        <ion-card-header>
          <ion-card-title>We’re here to help make every season a success.</ion-card-title>
          <ion-card-subtitle>Let’s Connect</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content class="contact-card__content">
          <p>
            Have a question or an idea you’d like to jam on? Drop us a note at
            <a href="mailto:chrisotto@swingmatch.ca">chrisotto@swingmatch.ca</a>
            or grab 30 minutes on Chris’ calendar.
          </p>
          <ion-button
            expand="block"
            color="success"
            fill="solid"
            href="https://calendly.com/chrisotto-swingmatch/30min"
            target="_blank"
            rel="noopener"
          >
            Book a Meeting
          </ion-button>
        </ion-card-content>
      </ion-card>
    </ion-content>
  </ion-page>
</template>

<script setup>
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonContent, IonPage } from '@ionic/vue'

import PurchasedPackagesBlock from '@/3_widgets/packages/PurchasedPackagesBlock.vue'
import ShareProfileBlock from '@/3_widgets/homepage/ShareProfileBlock.vue'
import UpcomingLessons from '@/3_widgets/homepage/UpcomingLessons.vue'
import { branding } from '@/globals'

import { useUserStore } from '@/stores/user'

const userStore = useUserStore()
</script>

<!-- <style>
ion-content::part(scroll) {
  background-image: url("@/assets/background1.jpeg");
  background-color: rgba(255, 255, 255, 0.3);
  background-blend-mode: overlay;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
}
ion-list, ion-item {
  --ion-item-background: transparent;
}
</style> -->

<style scoped>
.welcome-text, .welcome-text p {
  font-size: 1rem;
  line-height: 1.6;
  letter-spacing: 0.02rem;
}

.insights-card__actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.insights-card :deep(ion-card-subtitle) {
  color: rgba(19, 38, 30, 0.65);
}

.contact-card__content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  line-height: 1.55;
}

.contact-card__content p {
  margin: 0;
}

.contact-card__content a {
  font-weight: 600;
  color: #0f422a;
  text-decoration: none;
}

.contact-card__content a:hover {
  text-decoration: underline;
}
</style>
